var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 37.5L12.4719 50L25 37.5L20.3125 32.8125L15.625 37.5V20.1938C15.625 12.5031 22.1187 6.25 29.8062 6.25C37.4938 6.25 43.75 12.5031 43.75 20.1938C43.7483 22.1339 43.3422 24.0524 42.5578 25.8269C41.7733 27.6014 40.6276 29.193 39.1937 30.5L43.4062 35.1219C45.4811 33.2274 47.1388 30.9218 48.274 28.3517C49.4093 25.7816 49.997 23.0034 50 20.1938C50 9.05937 40.9406 0 29.8062 0C18.6719 0 9.375 9.05937 9.375 20.1875V37.5L4.6875 32.8125L0 37.5Z",
    fill: "#3788B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6875 27.9719C34.0022 27.9719 37.5 24.4741 37.5 20.1594C37.5 15.8446 34.0022 12.3469 29.6875 12.3469C25.3728 12.3469 21.875 15.8446 21.875 20.1594C21.875 24.4741 25.3728 27.9719 29.6875 27.9719Z",
    fill: "#3788B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.58c38972.svg";
export { ForwardRef as ReactComponent };